// src/api/employeeProfiles.js
import api from './axios';

/** Self: fetch my profile */
export async function fetchMyProfile() {
    const { data } = await api.get('/api/employee-profile');
    return data; // { exists, user:{id,name,email}, profile }
}

/** Self: create or update my profile */
export async function saveMyProfile(payload) {
    const { data } = await api.post('/api/employee-profile', payload);
    return data; // { message, profile }
}

/**
 * Manager: list team profiles with search/sort/pagination
 * params: { q?, sort_by?, sort_dir?, page?, per_page? }
 */
export async function listTeamProfiles(params = {}) {
    const { data } = await api.get('/api/employee-profiles', { params });
    return data; // { manager:{...}, data: {data:[...], current_page, last_page, ...} }
}

/** Manager: view a specific report’s profile */
export async function fetchProfileByUser(userId) {
    const { data } = await api.get(`/api/employee-profiles/${userId}`);
    return data; // { user:{...}, profile: {...}|null }
}


// === Me (My Profile) =====================================

export async function getMyEmployeeProfile() {
    const { data } = await api.get('/api/employee-profile');
    // data: { exists, user: {id,name,email}, profile: {...} | null }
    return data;
}

export async function saveMyEmployeeProfile(payload) {
    const { data } = await api.post('/api/employee-profile', payload);
    // data: { message, profile }
    return data;
}

// === Team (Manager view) =================================

// List direct reports with profile summary
export async function listTeamEmployeeProfiles(params = {}) {
    const { data } = await api.get('/api/employee-profiles', { params });
    // data: { manager: {...}, data: pagination }
    return data;
}

// Get a specific team member’s profile
export async function getTeamEmployeeProfile(userId) {
    const { data } = await api.get(`/api/employee-profiles/${userId}`);
    // data: { user: {...}, profile: {...} | null }
    return data;
}

// Manager creates/updates a team member’s profile
export async function saveTeamEmployeeProfile(userId, payload) {
    const { data } = await api.put(`/api/employee-profiles/${userId}`, payload);
    // data: { message, profile }
    return data;
}